export const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || "";

interface AnalyticsEventParams {
  [key: string]: string | number | boolean | null | undefined;
}

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
    __analyticsConsent?: boolean;
  }
}

import { AnalyticsEvent, EventPayloadMap } from "./events";

export function track(eventName: string, params: AnalyticsEventParams = {}) {
  if (!GA_ID || typeof window === "undefined") return;
  if (!window.__analyticsConsent) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}

export function trackTyped<E extends AnalyticsEvent>(
  event: E,
  params: EventPayloadMap[E]
) {
  track(event, params as AnalyticsEventParams);
}

export function pageView(path: string) {
  track("page_view", { page_path: path });
}

export function setUserProperties(props: AnalyticsEventParams) {
  if (!GA_ID || typeof window === "undefined") return;
  if (!window.__analyticsConsent) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("set", "user_properties", props);
}

export function isAnalyticsReady() {
  return !!(GA_ID && typeof window !== "undefined" && window.gtag);
}
